import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicDeviceRisk extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() } fillRule='evenodd'>
      <path
        d="M17.5,7C15.67,7,11,18.15,11,18.15a.83.83,0,0,0,.81.85H23.19a.83.83,0,0,0,.81-.85S19.33,7,17.5,7Zm0,10.8a.95.95,0,1,1,.9-.94A.92.92,0,0,1,17.51,17.8Zm.8-3.91a.81.81,0,1,1-1.62,0l-.41-3.43c0-.47.77-.85,1.22-.85s1.22.38,1.22.85Z"/>
      <path
        d="M14,21v.36a.64.64,0,0,1-.64.64H3.64A.64.64,0,0,1,3,21.36V2.64A.64.64,0,0,1,3.64,2H5a.64.64,0,0,1,.64.64.65.65,0,0,0,.64.65h4.5a.65.65,0,0,0,.64-.65A.64.64,0,0,1,12,2h1.33a.64.64,0,0,1,.64.64V7.7a8.46,8.46,0,0,1,2-2.24V1.38A1.41,1.41,0,0,0,14.56,0H2.44A1.41,1.41,0,0,0,1,1.38V22.63A1.41,1.41,0,0,0,2.44,24H14.56A1.41,1.41,0,0,0,16,22.63V21Z"/>
    </g>
  ]
  getViewBox = () => '0 0 24 24'
}
